import React, { createContext, useContext, useState } from 'react'
import { TourProvider } from '@reactour/tour'
import { useTranslation } from 'react-i18next'

const TourContext = createContext()

export const useTourContext = () => useContext(TourContext)

export const CustomTourProvider = ({ children }) => {
    const [segment, setSegment] = useState('')
    const [tourOpen, setTourOpen] = useState(false)

    const { t, locale } = useTranslation()

    return (
        <TourContext.Provider value={{ segment, setSegment, tourOpen, setTourOpen }}>
            <TourProvider
                scrollSmooth
                padding={{ mask: 10 }}
                onClickClose={({ setIsOpen }) => {
                    setIsOpen(false)
                    setTourOpen(false)
                }}
                onClickMask={({ setIsOpen }) => {
                    setIsOpen(false)
                    setTourOpen(false)
                }}
                prevButton={({ Button, currentStep, stepsLength, setCurrentStep, steps }) => {
                    const first = currentStep === 0
                    const last = currentStep === stepsLength - 1

                    return first || last ? null : (
                        <div style={{ transform: 'rotate(180deg)' }}>
                            <Button
                                onClick={() => {
                                    setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s - 1))
                                }}
                            ></Button>
                        </div>
                    )
                }}
                nextButton={({ Button, currentStep, stepsLength, setIsOpen, setCurrentStep, steps }) => {
                    const last = currentStep === stepsLength - 1
                    return last ? (
                        <button
                            onClick={() => {
                                localStorage.setItem(`tutorialSkipped-${segment}`, 'true')
                                setIsOpen(false)
                                setTourOpen(false)
                            }}
                        >
                            {last ? t("Don't show again") : null}
                        </button>
                    ) : (
                        <Button
                            onClick={() => {
                                setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
                            }}
                        >
                            {null}
                        </Button>
                    )
                }}
                onClickHighlighted={(e) => {
                    e.stopPropagation()
                }}
                disableInteraction
                styles={{
                    popover: (base) => ({
                        ...base,
                        '--reactour-accent': '#5E639B',
                        borderRadius: '10px',
                    }),
                    close: (base) => ({ ...base, left: 'auto', right: 15, top: 10 }),
                }}
            >
                {children}
            </TourProvider>
        </TourContext.Provider>
    )
}
